/** 在隔离 iframe 内创建图片地址；签名地址和网络请求始终留在宿主。 */
export function createComponentFileReferenceApi(
  call: (method: string, payload: Record<string, unknown>) => Promise<unknown>,
) {
  const runtime = globalThis as unknown as {
    Blob: typeof Blob;
    atob(value: string): string;
    URL: { createObjectURL(blob: unknown): string; revokeObjectURL(url: string): void };
    addEventListener(name: string, handler: () => void): void;
  };
  const urls = new Set<string>();
  let disposed = false;
  const releaseImageUrl = (url: string) => {
    if (urls.delete(url)) runtime.URL.revokeObjectURL(url);
  };
  runtime.addEventListener('pagehide', () => {
    disposed = true;
    for (const url of urls) releaseImageUrl(url);
  });
  const imageUrl = (blob: unknown) => {
    if (disposed) throw new Error('组件已卸载，不能继续读取图片');
    if (!(blob instanceof runtime.Blob) || !blob.type.startsWith('image/'))
      throw new Error('图片读取失败，文件内容不是图片');
    const url = runtime.URL.createObjectURL(blob);
    urls.add(url);
    return url;
  };
  return {
    async getImageUrl(
      reference: string | { fileId: string; scope?: 'component' | 'instance' },
      input: { thumbnail?: boolean } = {},
    ) {
      if (disposed) throw new Error('组件已卸载，不能继续读取图片');
      const blob = await call('files.image', {
        ...(typeof reference === 'string' ? { selectionRef: reference } : reference),
        thumbnail: input.thumbnail === true,
      });
      return imageUrl(blob);
    },
    async getRemoteImageUrl(input: { url: string }) {
      if (disposed) throw new Error('组件已卸载，不能继续读取图片');
      const image = (await call('files.previewImageFromUrl', { url: input.url })) as {
        contentType?: unknown;
        base64?: unknown;
      };
      if (
        !image ||
        typeof image.base64 !== 'string' ||
        image.base64.length > 4 * Math.ceil((2 * 1024 * 1024) / 3) ||
        !['image/png', 'image/jpeg', 'image/webp'].includes(String(image.contentType))
      )
        throw new Error('临时图片响应无效');
      let bytes: Uint8Array<ArrayBuffer>;
      try {
        bytes = Uint8Array.from(runtime.atob(image.base64), (value) => value.charCodeAt(0));
      } catch {
        throw new Error('临时图片内容无效');
      }
      if (!bytes.length || bytes.length > 2 * 1024 * 1024)
        throw new Error('临时图片为空或超过 2MB');
      return imageUrl(new runtime.Blob([bytes], { type: String(image.contentType) }));
    },
    releaseImageUrl,
  };
}
